import { useMemo } from "react";
import useModule from "./useModule";
import _ from "underscore";

const fieldsToIgnore = ["id"];

const useSortableFields = (moduleAPIName) => {
  const { module, modulesLoading } = useModule(moduleAPIName);

  const sortableFields = useMemo(() => {
    if (modulesLoading || !module?.Fields) return [];

    return _.filter(module?.Fields, (field) => {
      const type = field?.FieldType;
      if (!type || fieldsToIgnore.includes(field?.APIName)) return false;

      return [
        "Number",
        "Percent",
        "Text",
        "LongText",
        "Currency",
        "CurrencyInterval",
        "Date",
        "Time",
        "DateTime",
        "SingleSelect",
        "MultiSelect",
        "SingleReference",
        "MultiReference",
      ].includes(type);
    });
  }, [modulesLoading, module?.Fields]);

  return { sortableFields, loadingFields: modulesLoading };
};

export default useSortableFields;
